import {store} from "../../store";

export const userHasAdminAccess = (tokenData) => {

    // token data = store.user.decodedTokenData
    return (
        (tokenData?.sub_adm || []).length ||
        (tokenData?.funder_adm || []).length ||
        (tokenData?.pp_adm || []).length ||
        tokenData.admin
    )
}


export const hasFunderAdminPermissions = (tokenData) => {
    if (!tokenData) {
        const state = store.getState()
        tokenData = state.user.decodedTokenData;
    }
    return (
        (tokenData?.funder_adm || []).length ||
        tokenData.admin
    )
}

export const isSiteAdmin = (tokenData) => {
    if (!tokenData) {
        const state = store.getState()
        tokenData = state.user.decodedTokenData;
    }
    return !!tokenData.admin
}